import { fetchFromAPI } from "./fetch-from-api";

type GeneralFeedbackRequestBody = {
  contactable: boolean;
  feedback: string;
  submissionDate: string;
  submissionPath: string;
  userId?: string;
};

export const createGeneralFeedback = async (
  data: GeneralFeedbackRequestBody
): Promise<void> => {
  await fetchFromAPI("/general-feedback", {
    body: JSON.stringify(data),
    method: "POST",
  });
};
